// import one from "../assets/svg/projects/one.svg";
// import two from "../assets/svg/projects/two.svg";
// import three from "../assets/svg/projects/three.svg";
// import four from "../assets/svg/projects/four.svg";
// import five from "../assets/svg/projects/five.svg";
// import six from "../assets/svg/projects/six.svg";
// import seven from "../assets/svg/projects/seven.svg";
// import eight from "../assets/svg/projects/eight.svg";

// import React from "react";

export const projectsData = [

  {
    id: 1,
    projectName: "DriftMart",
    projectDesc:
      "A fully functional e-commerce platform includes reusable components, efficient state management, and responsive design.",
    tags: ["JavaScript","React","Redux","Tailwind CSS"],
    code: "https://github.com/sumansauravmay/DriftMart",
    demo: "https://symphonious-lollipop-6048de.netlify.app/",
    image: "https://i.postimg.cc/wvQ9xV3G/Drift-Mart-logo.png",
  },
  {
    id: 2,
    projectName: "RelianceDigital-Clone",
    projectDesc:
      "An Indian consumer electronics retailer includes reusable components, efficient state management, and responsive design.",
    tags: ["HTML", "CSS", "JavaScript","React","Redux","ChakraUI"],
    code: "https://github.com/Sonia-saini/-accidental-visitor-9960",
    demo: "https://melodic-syrniki-172917.netlify.app/",
    image: "https://i.postimg.cc/7h03ty2G/reliance-pic.jpg",
  },
  {
    id: 3,
    projectName: "Chat Bot AI",
    projectDesc:
      "This is a chatbot application. We can create Avatar AI and a chatbot AI with a natural UI where interaction happens through voice.",
    tags: ["JavaScript", "React", "Gemini API", "D-ID API"],
    code: "https://github.com/sumansauravmay/chatbo_ai",
    demo: "https://serene-clafoutis-25da20.netlify.app/",
    image: "https://i.postimg.cc/85HDR7yj/chatbot.jpg",
  },
  {
    id: 4,
    projectName: "TATA 1mg-Clone",
    projectDesc:
      "Tata 1mg is India’s leading consumer health platform. It provides services, including e-pharmacy, diagnostics, e-consultation and health content.",
    tags: ["JavaScript","React", "Redux", "NodeJS","ExpressJS","MongoDB"],
    code: "https://github.com/Ghanishtkhurana/brief-toes-9591",
    demo: "https://5mg-vivek-bhatt05.vercel.app/",
    image:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTKRcmRJ7xuNukTivouDSX6hVrRqKl1-iUcvAr1yd8_bA&s"
  },
  {
    id: 5,
    projectName: "KFC-Clone",
    projectDesc:
      "KFC is an American fast food restaurant chainand world 2nd largest restaurant chain.",
    tags: ["HTML", "CSS", "JavaScript", "React"],
    code: "https://github.com/sumansauravmay/alive-run-138/tree/main/kfctwo",
    demo: "https://kfctwo-sumansauravmay.vercel.app/",
    image: "https://thumbs.dreamstime.com/b/kfc-logo-kentucky-fried-chicken-global-fast-food-chain-sign-font-shop-60145767.jpg",
  },
   {
    id: 6,
    projectName: "Ayoa-Clone",
    projectDesc:
      "Ayoa is the original mind mapping app, pushing the boundaries of brainstorming tonew levels.",
    tags: ["HTML", "CSS", "JavaScript"],
    code: "https://github.com/omesh96/safe-bridge-5506",
    demo: "https://startling-youtiao-e9d129.netlify.app/",
    image: "https://i.postimg.cc/0yBLqp4Y/ayoa.jpg",
   }
];

// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/
